import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
  media: {
    height: 0,
    paddingTop: "56.25%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    backgroundBlendMode: "darken",
  },
  border: {
    border: "solid",
  },
  fullHeightCard: {
    height: "100%",
  },
  card: {
    display: "flex",
    cursor: "pointer",
    padding: "0 0 10px 0",
    flexDirection: "column",
    justifyContent: "space-between",
    borderRadius: "15px",
    height: "100%",
    position: "relative",
    boxShadow: "-10px 10px 40px rgba(0, 0, 0, 0.25)",
    webkitTransition: "all 0.3s ease",
    oTransition: "all 0.3s ease",
    transition: "all 0.3s ease",
    "&:hover": {
      webkitTransform: "translate(20px, -10px)",
      msTransform: "translate(10px, -10px)",
      transform: "translate(10px, -10px)",
      webkitBoxShadow: "0 20px 40px rgba(0, 0, 0, 0.08)",
      boxShadow: "10 20px 40px rgba(0, 0, 0, 0.08)",
    },
  },
  overlay: {
    position: "absolute",
    top: "20px",
    left: "20px",
    color: "white",
  },
  overlay2: {
    position: "absolute",
    top: "20px",
    right: "20px",
    color: "white",
  },
  grid: {
    display: "flex",
  },
  details: {
    display: "flex",
    justifyContent: "space-between",
    margin: "20px",
  },
  title: {
    padding: "0 16px",
    fontFamily: "merriweather",
  },
  cardActions: {
    padding: "0 16px 8px 16px",
    display: "flex",
    justifyContent: "space-between",
  },
  message: {
    textAlign: "justify",
    paddingLeft: "30px",
    paddingRight: "30px",
    fontFamily: "Open Sans",
    fontSize: "14px",
    color: "#6A6A6A",
    lineHeight: "18px",
    marginBottom: "10px",
  },
  creator: {
    fontFamily: "merriweather",
  },
  cardAction: {
    display: "block",
    textAlign: "initial",
  },
});
